export default {
  paperClass: {
    marginLeft: ({ noMargin }) => !noMargin && 16,
    margin: ({ margin }) => margin || null
  }
}
